// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 43 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M29 3C34.52 3 39 7.48 39 13C39 18.52 34.52 23 29 23C23.48 23 19 18.52 19 13C19 7.48 23.48 3 29 3Z"
				fill={props.color}
			/>
			<rect
				x="0.75"
				y="0.75"
				width="41.5"
				height="24.5"
				rx="12.25"
				stroke={props.color}
				strokeWidth="1.5"
			/>
		</svg>
	</>
);

export default Icon;
